import { FlightItineraryGroupNode } from '@app/generated/graphql';

export function getFlightItineraryRoute(group: FlightItineraryGroupNode) {
  const departure = group.departureAirport;
  const arrival = group.arrivalAirport;

  return `${departure.cityName} (${departure.locationCode}) → ${arrival.cityName} (${arrival.locationCode})`;
}

export function getFlightItineraryDepartureAt(group: FlightItineraryGroupNode) {
  return group.segments?.[0]?.flightSegment?.departureAtAirportTimeZone || group.departureAt;
}

export function getFlightItineraryStopsLabel(group: FlightItineraryGroupNode) {
  const segments = group.segments || [];

  if (segments.length <= 1) {
    return null;
  }

  const stopCodes = segments
    .slice(0, -1)
    .map((segment) => segment.flightSegment.arrivalAirport?.locationCode)
    .filter(Boolean);

  if (stopCodes.length === 1) {
    return `1 stop via ${stopCodes[0]}`;
  }

  return `${stopCodes.length} stops via ${stopCodes.join(', ')}`;
}
